/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-09-25
 * @Company: Copyright 2020 Abi Akindele | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: mc-central-ts: business routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const projectRoutes: Array<RouteRecordRaw> = [
  {
    path: '/projects',
    name: 'projects',
    redirect: '/projects/mcaccess',
    component: () => import('pages/mc/McPage.vue'),
    meta: {
      title: 'Projects',
    },
    children: [
      {
        path: 'mcaccess',
        name: 'mcaccess',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Shared Services',
        },
      },
      {
        path: 'mcpa',
        name: 'mcpa',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Policy Automation',
        },
      },
      {
        path: 'mcpay',
        name: 'mcpay',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Payment Service',
        },
      },
      {
        path: 'mcship',
        name: 'mcship',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Shipping Service',
        },
      },
      {
        path: 'mcsupport',
        name: 'mcsupport',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Support Services',
        },
      },
      {
        path: 'mcsurvey',
        name: 'mcsurvey',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Survey Services',
        },
      },
      {
        path: 'mcinfo',
        name: 'mcinfo',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Information Marketplace',
        },
      },
      {
        path: 'mcweb',
        name: 'mcweb',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Web UI Solution',
        },
      },
      {
        path: 'mcbc',
        name: 'mcbc',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Blockchain service engine',
        },
      },
      {
        path: 'mcts',
        name: 'mcts',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Marketplace Trading & Services',
        },
      },
      {
        path: 'mctrade',
        name: 'mctrade',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Marketplace Trading',
        },
      },
      {
        path: 'mcpackage',
        name: 'mcpackage',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Packages - mcpackages',
        },
      },
      {
        path: 'mcprojects',
        name: 'mcprojects',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Hosted Marketplace Projects',
        },
      },
      {
        path: 'mcpro',
        name: 'mcpro',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Productivity Toolkits',
        },
      },
    ],
  },
];
